<template>
  <span :class="{ noShow }">
    <ImportDialog
      ref="importDialog"
      :title="title"
      :fileUrl="fileUrl"
      :bizCodes="bizCodes"
      :downloadDesc="downloadDesc"
      :downloadTipsShow="downloadTipsShow"
      :tipDesc1="tipDesc1"
      :tipDesc2="tipDesc2"
      :tipDesc3="tipDesc3"
      :isCustomDownload="isCustomDownload"
      :isDownloadLocalTemplate="isDownloadLocalTemplate"
      :fileType="fileType"
      @customDownload="customDownload"
      @sub="handleImport"
    />
    <el-button type="primary" @click="showImportDialog" plain>
      <i class="iconfont">&#xe6ac;</i>{{ btnName || '导入' }}
    </el-button>
  </span>
</template>

<script>
import {
  importPost,
} from 'api';
import ImportDialog from 'components/importDialog';
// const md5 = require('md5');
export default {
  components: {
    ImportDialog,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    fileUrl: {
      default: '',
    },
    downloadTipsShow: {
      type: Boolean,
      default: true,
    },
    btnName: {
      type: String,
      default: '',
    },
    bizCodes: {
      default: '',
    },
    // 同一入口包含多个模板时，优先使用后端配置的业务分组校验，
    // 避免通过用户本地文件名反推 bizCode（文件重命名后会得到空串）。
    groupCode: {
      type: String,
      default: '',
    },
    customPost: {
      type: Boolean,
      default: false,
    },
    // 是否下载本地模板
    isDownloadLocalTemplate: {
      type: Boolean,
      default: false,
    },
    // 是否自定义下载操作
    isCustomDownload: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    noShow: {
      type: Boolean,
      default: false,
    },
    downloadDesc: {
      type: String,
      default: '',
    },
    tipDesc1: {
      type: String,
      default: '',
    },
    tipDesc2: {
      type: String,
      default: '',
    },
    tipDesc3: {
      type: String,
      default: '',
    },
    fileData: {
      type: Object,
      default: () => (null),
    },
    // 设置选择文件的格式
    fileType: {
      type: String,
      default: '',
    },
  },
  methods: {
    // 外部自定义操作
    customDownload () {
      this.$emit('customDownload');
    },
    showImportDialog () {
      this.$refs.importDialog.show(true);
    },
    handleImport (file) {
      this.$refs.importDialog.show(false);
      let bizCodes = '';
      if (this.groupCode) {
        // checkFileData 会从模板题头解析具体业务，并校验其属于该 groupCode。
        bizCodes = '';
      } else if (typeof this.bizCodes === 'string') {
        bizCodes = this.bizCodes;
      } else {
        for (let i = 0; i < this.fileUrl.length; i++) {
          let fileName = this.fileUrl[i].split('.xlsx')[0].split('/');
          fileName = fileName[fileName.length - 1];
          if (file.name.indexOf(fileName) !== -1) {
            bizCodes = this.bizCodes[i];
            break;
          }
        }
      }
      if (this.customPost) {
        this.$emit('sub', {
          bizCodes,
          file,
        });
      } else {
        console.log(file);
        importPost({
          data: {
            bizCodes,
            groupCode: this.groupCode,
            file,
          },
          fileData: this.fileData,
          type: this.type,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.noShow {
  position: absolute;
  left: -20000px;
}
</style>
